import React, { Component } from 'react'
import { Link } from 'react-router'
import { Glyphicon, Panel, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

/* Copy from https://stackoverflow.com/a/901144*/
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const styles = {
  panel: { 
    margin : "40px", 
    padding: 20,
    border: "1px solid #ccc", 
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignContent: "center",
    alignItems: "center"
  },
  label: { display: "block" },
  button: { 
    marginTop: "20px",
    border: "1px solid black",
    borderRadius: "black",
    padding: 5
  },
  inputGroup: { marginBottom: "20px" }, 
  input: { maxWidth: "200px" }
}

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = { username: "" }
  }

  render() {
    return (
      <div style={styles.panel}>
        <form action="/api/login" method="post">

          <div controlId="login-name">
            <label style={styles.label}>Nombre</label>
            <input 
              type="text" 
              name="username" 
              style={styles.input}
              value={this.state.username}
              onChange={evt => this.setState({ username: evt.target.value })}
            />
          </div>

          <div controlId="login-pwd">
            <label style={styles.label}>Contraseña</label>
            <input type="password" name="password" style={styles.input} />
          </div>

          <input type="text" name="redirect" style={{display: "none"}} value={getParameterByName("redirectTo")}  />
          
          <a 
            href={`/requestpasswordreset/${this.state.username}`} 
            style={{fontWeight: "bold", fontSize: "15px"}}
          >
            Olvidé mi contraseña
          </a>

          <br />

          <button type="submit" style={styles.button} glyph="log-in" bsSize="normal">
            Entrar
          </button>
        </form>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/app/admin/components/Login.jsx